import { render, staticRenderFns } from "./reward-recordv2.vue?vue&type=template&id=dc876e52&scoped=true&"
import script from "./reward-recordv2.vue?vue&type=script&lang=js&"
export * from "./reward-recordv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc876e52",
  null
  
)

export default component.exports